
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/7012d1ed0225cfc4bba0161dc27b2468/492a50073aefd787718d6c2300220c9a.png" 
              alt="Burtman's Painting" 
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              About
            </button>
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Services
            </button>
            <button onClick={() => scrollToSection('gallery')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className={`px-6 py-2.5 bg-teal-600 text-white text-sm font-medium rounded-full hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer`}>
              Get Free Quote
            </button>
          </div>

          <button 
            className="md:hidden text-2xl cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col space-y-3 px-4 py-3">
              <button onClick={() => scrollToSection('home')} className="text-sm font-medium text-gray-700 hover:text-teal-600 text-left cursor-pointer">
                Home
              </button>
              <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-gray-700 hover:text-teal-600 text-left cursor-pointer">
                About
              </button>
              <button onClick={() => scrollToSection('services')} className="text-sm font-medium text-gray-700 hover:text-teal-600 text-left cursor-pointer">
                Services
              </button>
              <button onClick={() => scrollToSection('gallery')} className="text-sm font-medium text-gray-700 hover:text-teal-600 text-left cursor-pointer">
                Gallery
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-sm font-medium text-gray-700 hover:text-teal-600 text-left cursor-pointer">
                Testimonials
              </button>
              <button onClick={() => scrollToSection('contact')} className="px-6 py-2.5 bg-teal-600 text-white text-sm font-medium rounded-full hover:bg-teal-700 transition-colors text-center cursor-pointer">
                Get Free Quote
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
